// export factory function
import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';

export const useStatementStore = defineStore('profile-statement', () => {
    const state = reactive({
        statement: '',
    });

    const filled = computed(() => typeof state.statement === 'string' && state.statement.length > 0);

    function updateFromQuery(statement) {
        state.statement = statement;
    }

    return {
        ...toRefs(state),
        updateFromQuery,
        filled,
    };
});
